export const commonCountries = ['DE', 'CH', 'AT', 'US', 'GB', 'FR', 'RU'];

export const continentSort = ['europe', 'oceania', 'asia', 'africa', 'america'];

// known http status codes
export const HttpStatusCode = {
  Created: 201,
  Forbidden: 403,
  InternalError: 0,
  InvalidData: 422,
  MethodNotAllowed: 405,
  NoContent: 204,
  NotFound: 404,
  Ok: 200,
  ServiceUnavailable: 503,
  TokenExpired: 412,
  TooManyRequests: 429,
  Unauthorized: 401,
  Unknown: 500,
};
